// extracted by mini-css-extract-plugin
module.exports = {"products":"QJ-z","misad":"RJ-z","oosMessaging":"SJ-z","topProductFrame":"TJ-z","productCardOverrides":"UJ-z","secondRowAds":"VJ-z","microsoftAdsWrapper":"WJ-z"};